export default __webpack_public_path__ + "static/media/080_finish_soso.vp9.66553016.webm";